export default __webpack_public_path__ + "static/testing-e6ccb71e5a52d457f6e13589c66b2e4d.png";